/**
 * @deprecated This container is no longer necessary in order to prevent styles from leaking into the global scope.
 * When using the scoped CSS reset functionality be sure to wrap the Alle Elements
 * with this class name or else you will not get the correct styling.
 */
export const CSS_RESET_CLASSNAME = 'alle-elements-reset';
/**
 * @internal
 * @deprecated
 * Internal use only. Do not use this in your application
 * */
export const CSS_RESET_IGNORE_CLASSNAME = 'alle-elements-ignore-reset';

export const BREAKPOINT_2XL_MIN = '1537px';
export const BREAKPOINT_2XL_MAX = '2506px';

export const BREAKPOINT_XL_MIN = '1280px';
export const BREAKPOINT_XL_MAX = '1536px';

export const BREAKPOINT_LG_MIN = '769px';
export const BREAKPOINT_LG_MAX = '1279px';

export const BREAKPOINT_MD_MIN = '481px';
export const BREAKPOINT_MD_MAX = '768px';

export const BREAKPOINT_SM_MIN = '288px';
export const BREAKPOINT_SM_MAX = '480px';

export const BREAKPOINT_XS_MIN = '0px';
export const BREAKPOINT_XS_MAX = '287px';

export const NAVBAR_HEIGHT = '56px';

export const BASE_FONT_SIZE_PX = 16;

export const BASE_THEME_STYLES = {
  styles: {
    global: {
      body: {
        fontFamily: '',
        color: '',
        background: '',
        transitionProperty: '',
        transitionDuration: '',
        lineHeight: '',
      },
      '*::placeholder': {
        color: '',
      },
      '*, *::before, &::after': {
        borderColor: '',
        wordWrap: '',
      },
      '.screen-reader': {
        border: '0',
        clip: 'rect(0 0 0 0)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px',
      },
      '.screen-reader-focusable:active,.screen-reader-focusable:focus': {
        clip: 'auto',
        height: 'auto',
        margin: '0',
        overflow: 'visible',
        position: 'static',
        whiteSpace: 'normal',
        width: 'auto',
      },
    },
  },
  breakpoints: {
    base: BREAKPOINT_SM_MIN,
    sm: BREAKPOINT_SM_MAX,
    md: BREAKPOINT_MD_MAX,
    lg: BREAKPOINT_LG_MAX,
    xl: BREAKPOINT_XL_MAX,
    '2xl': BREAKPOINT_2XL_MAX,
  },
};
